/**
 * The remembered council, ported from the static build's lib/council.jsx.
 * Stored with its own expiry (90 days; the entry dialog's dismissal 30 days)
 * in the same keys and shape, so a visitor keeps their choice across builds.
 */

const KEY = 'ss_council';
const DISMISS = 'ss_popup_dismissed';
const DAY = 86400000;

const read = (key) => {
	try {
		const raw = window.localStorage.getItem(key);
		if (!raw) return null;
		const { v, exp } = JSON.parse(raw);
		if (exp && Date.now() > exp) {
			window.localStorage.removeItem(key);
			return null;
		}
		return v;
	} catch (e) {
		return null;
	}
};

const write = (key, v, days) => {
	try {
		window.localStorage.setItem(key, JSON.stringify({ v, exp: Date.now() + days * DAY }));
	} catch (e) {
		// Storage blocked: the choice lasts for this page view only.
	}
};

const councils = () => (Array.isArray(window.awddCouncils) ? window.awddCouncils : []);
const bySlug = (slug) => councils().find((c) => c.slug === slug) || null;

let slug = read(KEY);
if (slug && !bySlug(slug)) slug = null; // A council that no longer exists.

const announce = () => window.dispatchEvent(new CustomEvent('council-change', { detail: { council: current() } }));

export function current() {
	return slug ? bySlug(slug) : null;
}

export function choose(next) {
	if (!bySlug(next)) return;
	slug = next;
	write(KEY, next, 90);
	announce();
}

export function forget() {
	slug = null;
	try {
		window.localStorage.removeItem(KEY);
	} catch (e) {
		// Nothing stored to remove.
	}
	announce();
}

export function dismiss() {
	write(DISMISS, 1, 30);
}

export function isDismissed() {
	return Boolean(read(DISMISS));
}

export function onChange(fn) {
	window.addEventListener('council-change', (e) => fn(e.detail.council));
}

export function initCouncil() {
	// Landing on a council page sets the context, and must not raise the entry dialog.
	const landed = document.body.dataset.awddCouncil;
	if (landed && landed !== slug) choose(landed);
	announce();
}
